
const Branding = () => {
  return (
    <div>
      <a href={process.env.REACT_APP_MOTILAL_MF_MODULE_URL} title="Motilal Oswal Asset Management Company" className="tw-relative tw-block tw-h-[80px] tw-w-[137px]">
        <img
          src={"/mutualfund/assets/images/footer/mo_footer_logo.webp"}
          alt="Motilal Oswal Asset Management Company"
          fill
          className="tw-object-contain tw-h-[80px] tw-w-[137px]"
        />
      </a>
      <h6 className="tw-text-base tw-leading-6 md:tw-leading-5 tw-font-semibold tw-m-0 tw-mt-3 md:tw-mt-4">Motilal Oswal Asset Management Company</h6>
    </div>
  )
}

export default Branding